import { mutatorAction } from "satcheljs";
import { getIrisCampaignDialogStore } from "../store/IrisCampaignDialogStore";
import type { IrisCampaignDialogViewState, IrisDialogSelectionData, } from "../store/schema/irisCampaignDialogState";

export const setIrisDialogAccountMutator: (accountKey: string) => void = mutatorAction("setIrisDialogAccount", (accountKey: string): void => {
    const store = getIrisCampaignDialogStore();
    if (store.accountKey !== accountKey) {
        store.accountKey = accountKey;
        store.requestId++;
        store.viewState = "idle";
        store.dialog = undefined;
        store.impressionLogged = false;
    }
});

export const setIrisCampaignDialogStateMutator: (requestId: number, viewState: Exclude<IrisCampaignDialogViewState, "idle">, dialog?: IrisDialogSelectionData) => void = mutatorAction("setIrisCampaignDialogState", (requestId: number, viewState: Exclude<IrisCampaignDialogViewState, "idle">, dialog?: IrisDialogSelectionData): void => {
    const store = getIrisCampaignDialogStore();
    if (store.requestId !== requestId ||
        (viewState === "ready" && (store.viewState !== "loading" || !dialog))) {
        return;
    }
    store.viewState = viewState;
    if (dialog) {
        store.dialog = dialog;
    }
});

export const markIrisDialogImpressionMutator: (requestId: number) => void = mutatorAction("markIrisDialogImpression", (requestId: number): void => {
    const store = getIrisCampaignDialogStore();
    if (store.requestId === requestId && store.viewState === "ready") {
        store.impressionLogged = true;
    }
});
